
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/pickup/chevrolet-silverado",
      function () {
        return require("private-next-pages/tyres/pickup/chevrolet-silverado.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/pickup/chevrolet-silverado"])
      });
    }
  